import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import TextField from '../textField/TextField';
import TextFieldPassaport from '../textField/TextFieldPassport';
import SelectField from '../selectField/SelectField';
import AgeField from '../ageField/AgeField';
import EmailField from '../emailField/EmailField';
import I18n from 'i18n-react';
import isRequiredIf from '../../modules/react-conditional-required';
import PassengerInfo from '../../../const/PassengersInfo';

import './PassengerForm.css';
import '../../tooltip/ToolTip.css';
import Country from '../../../const/Country';
import SelectFieldCountry from '../selectField/SelectFieldCountry';
import DateField from '../dateField/DateField';
/* eslint-disable*/
const INFANT = 'IN';

const propTypes = {
  id: PropTypes.string.isRequired,
  passengerNumber: PropTypes.string.isRequired,
  passengerType: PropTypes.string.isRequired,
  lastFlightDate: PropTypes.string.isRequired,
  valueName: PropTypes.string,
  changeName: PropTypes.func.isRequired,
  valueLastName: PropTypes.string,
  changeLastName: PropTypes.func.isRequired,  
  valueGender: PropTypes.string,
  changeGender: PropTypes.func.isRequired,
  valueAge: PropTypes.string,
  changeAge: PropTypes.func.isRequired,
  valueEmail: PropTypes.string,
  valuePassport: PropTypes.string,
  changePassport: PropTypes.func.isRequired,
  valueNationality: PropTypes.string,
  changeNationality: PropTypes.func.isRequired,
  valueCountryPassport: PropTypes.string,
  changeCountryPassport: PropTypes.func.isRequired,
  valueExpirationDatePassport: PropTypes.string,
  changeExpirationDatePassport: PropTypes.func.isRequired,
  changeEmail: isRequiredIf(PropTypes.func, props => props.passengerType !== INFANT),
  changeTravellingWith: isRequiredIf(PropTypes.func, props => props.passengerType === INFANT),
  travellingWithValues: isRequiredIf(
    PropTypes.arrayOf(PropTypes.string),
    props => props.passengerType === INFANT
  ),
  travellingWithDefaultValue: PropTypes.string,
  hidePassengerTitle: PropTypes.bool,
  isFieldsEnabled: PropTypes.bool,
  isRenderIconEdit: PropTypes.bool,
  isCallcenterEnabled: PropTypes.bool,
  isPassengerComarch: PropTypes.bool
};

const defaultValues = {
  travellingWithDefaultValue: '',
  hidePassengerTitle: false,
  valueName: null,
  valueLastName: null,  
  valueGender: null,
  valueAge: null,
  valueEmail: null,
  valuePassport: null,
  valueNationality: null,
  valueCountryPassport: null,
  valueExpirationDatePassport: null
};

class PassengerForm extends React.Component {
  renderTitle() {
    if (!this.props.hidePassengerTitle) {
      return (
        <Row id={`passengerInfoForm-${this.props.id}-title`}>
          <Col xs={12} className="PassengerInfo__titleInfo">
            <label className="PassengerInfo__title">
              {I18n.translate('components.passengerInfo.form.title')}
              <label className="PassengerInfo__title PassengerInfo--titleType">
                {I18n.translate('components.passengerInfo.form.passengerNumber', {
                  number: this.props.passengerNumber
                })}{' '}
                ({I18n.translate(`components.passengerInfo.form.${this.props.passengerType}`)})
              </label>
            </label>
            {this.props.passengerType === INFANT && (
              <label className="PassengerInfo__subtitle">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.voeazul.com.br/br/pt/sua-viagem/planeje/voos-com-crianca">
                  {I18n.translate('components.passengerInfo.form.babySubTitle1')}
                </a>
                {I18n.translate('components.passengerInfo.form.babySubTitle2')}
              </label>
            )}
          </Col>
        </Row>
      );
    } else {
      return (
        <Row id={`passengerInfoForm-${this.props.id}-title`}>
          <Col xs={12} className="PassengerInfo__titleInfo">
            <label className="PassengerInfo__title">
              {I18n.translate('components.passengerInfo.form.title2')}
              <label className="PassengerInfo__title PassengerInfo--titleType">
                {I18n.translate('components.passengerInfo.form.passengerNumber', {
                  number: this.props.passengerNumber
                })}{' '}
                ({I18n.translate(`components.passengerInfo.form.${this.props.passengerType}`)})
              </label>
            </label>
          </Col>
        </Row>
      );
    }
  }

  renderTravelWith() {
    let travellingWith;

    if (this.props.passengerType === INFANT) {
      travellingWith = (
        <Row id={`passengerInfoForm-${this.props.id}-travellingWithInfo`}>
          <Col xs={12} md={3} className="PassengerInfo__travellingWith">
            <SelectField
              id={`passengerInfoForm-${this.props.id}-travellingWith`}
              ref={this.createRef}
              label="components.passengerInfo.travellingWith.label"
              required={true}
              errorMessage="components.passengerInfo.travellingWith.errorMessage"
              placeholder="components.passengerInfo.travellingWith.placeholder"
              values={this.props.travellingWithValues}
              default={this.props.travellingWithDefaultValue}
              changeValue={this.props.changeTravellingWith}
            />
          </Col>
        </Row>
      );
    }

    return travellingWith;
  }

  createRef = value => {
    if (value) {
      if (!this.fields) {
        this.fields = [];
      }
      this.fields[this.fields.length] = value;
    }
  };

  parseNameNoEspecialCharacter(value) {
    return value.normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '').toUpperCase();
  }

  removeSpaceAndConsiderInMiddle(value) {
   return value.trim().replace(/\s\s+/g, ' ');
  }

  renderNameInfo() {
    let valueName = this.props.valueName !== null ?
    this.parseNameNoEspecialCharacter(this.props.valueName) :
    this.props.valueName;
     
    let valueLastName = this.props.valueLastName !== null ?
      this.removeSpaceAndConsiderInMiddle(this.props.valueLastName) :
      this.props.valueLastName;
    
    return (
      <Row id={`passengerInfoForm-${this.props.id}-nameInfo`}>
        <div>
          <Col xs={12} md={3} className="PassengerInfo__name">
            <TextField
              id={`passengerInfoForm-${this.props.id}-name`}
              ref={this.createRef}
              label="components.passengerInfo.name.label"
              placeholder="components.passengerInfo.name.placeholder"
              maxLength={50}
              value={valueName}
              required={true}
              trim={false}
              isUpperCase={true}
              errorMessage="components.passengerInfo.name.errorMessage"
              changeValue={this.props.changeName}
              isFieldsEnabled={this.props.isFieldsEnabled}
              isName={true}
              isRenderIconEdit={this.props.isRenderIconEdit}
            />
          </Col>
        </div>
        <div>
          <Col xs={12} md={3} className="PassengerInfo__lastName">
            <TextField
              id={`passengerInfoForm-${this.props.id}-lastName`}
              ref={this.createRef}
              label="components.passengerInfo.lastName.label"
              placeholder="components.passengerInfo.lastName.placeholder"
              maxLength={50}
              value={valueLastName}
              required={true}
              trim={false}
              isUpperCase={true}
              errorMessage="components.passengerInfo.lastName.errorMessage"
              changeValue={this.props.changeLastName}
              isFieldsEnabled={this.props.isFieldsEnabled}
              isName={false}
              isRenderIconEdit={this.props.isRenderIconEdit}
            />
          </Col>
        </div>
      </Row>
    );
  }

  renderPersonalInfo() {
    return (
      <Row id={`passengerInfoForm-${this.props.id}-personalInfo`}>
        <Col xs={12} md={3} className="PassengerInfo__gender">
          <SelectField
            id={`passengerInfoForm-${this.props.id}-gender`}
            ref={this.createRef}
            label="components.passengerInfo.gender.label"
            required={true}
            errorMessage="components.passengerInfo.gender.errorMessage"
            placeholder="components.passengerInfo.gender.placeholder"
            values={[PassengerInfo.GENDER_FEMALE, PassengerInfo.GENDER_MALE]}
            default={this.props.valueGender}
            changeValue={this.props.changeGender}
            isFieldsEnabled={this.props.isFieldsEnabled}
            isRenderIconEdit={this.props.isRenderIconEdit}
          />
        </Col>
        <Col xs={12} md={3} className="PassengerInfo__age">
          <AgeField
            id={`passengerInfoForm-${this.props.id}-age`}
            ref={this.createRef}
            label="components.passengerInfo.birthdate.label"
            placeholder="components.passengerInfo.birthdate.placeholder"
            value={this.props.valueAge}
            required={true}
            errorMessage="components.passengerInfo.birthdate.errorMessage"
            passengerType={this.props.passengerType}
            lastFlightDate={this.props.lastFlightDate}
            changeValue={this.props.changeAge}
            isFieldsEnabled={this.props.isFieldsEnabled}
            isRenderIconEdit={this.props.isRenderIconEdit}
            isCallcenterEnabled={this.props.isCallcenterEnabled}
            isPassengerComarch={this.props.isPassengerComarch}
          />
        </Col>
        {this.renderEmailInfo()}
      </Row>
    );
  }

  renderEmailInfo() {
    let emailField;

    if (this.props.passengerType !== INFANT) {
      emailField = (
        <Col xs={12} md={3} className="PassengerInfo__email">
          <EmailField
            id={`passengerInfoForm-${this.props.id}-email`}
            ref={this.createRef}
            label="components.passengerInfo.email.label"
            placeholder="components.passengerInfo.email.placeholder"
            value={this.props.valueEmail}
            required={true}
            maxLength={60}
            changeValue={this.props.changeEmail}
            isFieldsEnabled={this.props.isFieldsEnabled}
            isRenderIconEdit={this.props.isRenderIconEdit}
          />
        </Col>
      );
    }

    return emailField;
  }

  renderPassport1Info() {
    let passportField;
    passportField = (
      <Row id={`passengerInfoForm-${this.props.id}-emailInfo`}>
        <Col xs={12} md={3} className="PassengerInfo__lastName">
          <TextFieldPassaport
            id={`passengerInfoForm-${this.props.id}-passport`}
            ref={this.createRef}
            label="components.passengerInfo.passport.label"
            placeholder="components.passengerInfo.passport.placeholder"
            maxLength={12}
            value={this.props.valuePassport}
            required={false}
            changeValue={this.props.changePassport}
          />
        </Col>
        <Col xs={12} md={3} className="PassengerInfo__lastName">
          <SelectFieldCountry
            id={`passengerInfoForm-${this.props.id}-nationality`}
            ref={this.createRef}
            label="components.passengerInfo.nationality.label"
            placeholder="components.passengerInfo.nationality.placeholder"
            required={false}
            changeValue={this.props.changeNationality}
            values={this.inputCountry()}
          />
        </Col>
        <Col xs={12} md={3} className="PassengerInfo__lastName">
          <SelectFieldCountry
            id={`passengerInfoForm-${this.props.id}-countryPassport`}
            ref={this.createRef}
            label="components.passengerInfo.countryPassport.label"
            placeholder="components.passengerInfo.countryPassport.placeholder"
            values={this.inputCountry()}
            required={false}
            changeValue={this.props.changeCountryPassport}
          />
        </Col>

      </Row>
    );
    return passportField;
  }

  inputCountry() {
    let paises = [];
    Object.keys(Country).forEach(pais => {
      paises.push(Country[pais]);
    });
    return paises;
  }

  renderExpirationDatePassportInfo() {
    let expirationDatePassportField;
    expirationDatePassportField = (
      <Row id={`passengerInfoForm-${this.props.id}-expirationDatePassportInfo`}>
        <Col xs={12} md={3} className="PassengerInfo__lastName">
          <DateField
            id={`passengerInfoForm-${this.props.id}-expirationDatePassport`}
            ref={this.createRef}
            label="components.passengerInfo.expirationDatePassport.label"
            placeholder="components.passengerInfo.expirationDatePassport.placeholder"
            value={this.props.valueExpirationDatePassport}
            required={false}
            lastFlightDate={this.props.lastFlightDate}
            changeValue={this.props.changeExpirationDatePassport}
          />
        </Col>
      </Row>
    );
    return expirationDatePassportField;
  }


  render() {
    return (
      <Row id={`passengerInfoForm-${this.props.id}`} className="PassengerInfo">
        <Col xs={12}>
          {this.renderTitle()}
          {this.renderTravelWith()}
          {this.renderNameInfo()}
          {this.renderPersonalInfo()}
          {this.renderPassport1Info()}
          {this.renderExpirationDatePassportInfo()}
        </Col>
      </Row>
    );
  }
}

PassengerForm.propTypes = propTypes;
PassengerForm.defaultValues = defaultValues;

export default PassengerForm;



// WEBPACK FOOTER //
// ./src/components/passengerInfo/passengerForm/PassengerForm.jsx